const Menu = require('react-burger-menu').slide;
import React, { Component, PropTypes } from 'react'
import dateFormat from 'date-fns/format'
import { Link } from 'react-router'

class Main extends Component {
  constructor(props){
    super(props);
    this.state = {
      isOpen: false,
    }
  }
  saveMenuState(state){
    this.setState({
      isOpen: state.isOpen
    })
  }
  handleNavClick(){
    this.setState({
      isOpen: false
    })
  }
  render(){
    let state = this.state
    return (
      <main>
        <nav className = 'nav-container'>
          <h1>R<span className = 'redO'>O</span>B<span className = 'yellowO'>O</span>T REB<span className = 'greenO'>O</span><span className = 'blueO'>O</span>T</h1>
          <ul className='nav'>
            <li className='nav-item'><Link to="/classic">Practice</Link></li>
            <li className='nav-item'><Link to="/challenge">Daily Challenge <i className="fa fa-cogs"></i> </Link></li>
            <li className='nav-item'><Link to="/highscore">High Scores <i className="fa fa-cogs"></i> </Link></li>
            <li className='nav-item'><Link to="/about">About</Link></li>
          </ul>
        </nav>
        <Menu className = 'mobile-nav-container' onStateChange={ this.saveMenuState.bind(this) } isOpen = { state.isOpen } >
          <ul>
            <li><Link onClick = { this.handleNavClick.bind(this) } id="classic" className="menu-item" to="/classic">Practice</Link></li>
            <li><Link onClick = { this.handleNavClick.bind(this) } id="challenge" className="menu-item" to="/challenge">Daily Challenge <i className="fa fa-cogs"></i> </Link></li>
            <li><Link onClick = { this.handleNavClick.bind(this) } id="highscore" className="menu-item" to="/highscore">High Scores <i className="fa fa-cogs"></i></Link></li>
            <li><Link onClick = { this.handleNavClick.bind(this) } id="about" className="menu-item" to="/about">About</Link></li>
          </ul>
        </Menu>
        <div className="content-container">
          {this.props.children}
        </div>
      </main>
    )
  }
}

export default Main



// WEBPACK FOOTER //
// ./containers/Main.js